//Initialize Accordion
if (document.querySelector(".accordion-container")) {
  new Accordion(".accordion-container");
}

//Carousel Script
if (document.querySelector(".glide__slides")) {
  var allSlides = document.querySelectorAll(".glide");
  var allSlidesArray = Array.prototype.slice.call(allSlides);
  allSlidesArray.forEach((slide) => {
    const glide = new Glide(slide, {
      type: "carousel",
      perView: 3,
      perTouch: 1,
      focusAt: 1,
      autoplay: false,
      accessibility: true,
      startAt: 2,
      rewind: true,
      draggable: true,
      swipeThreshold: 80,
      dragThreshold: 120,
      classes: {
        disabledArrow: "glide__arrow--disabled",
      },
      peek: {
        before: 300,
        after: 250,
      },
      perSwipe: "|",
      breakpoints: {
        800: {
          perView: 1,
          draggable: true,
          perTouch: 1,
          startAt: 0,
          peek: 0,
          swipeThreshold: 10,
          dragThreshold: 20,
        },
      },
    }).mount();
  });
}

//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
  allBtns.forEach((btn) => {
    if (btn.hasAttribute("href")) {
      let ctaLink = btn.getAttribute("href").split("/");

      if (ctaLink[2] !== currentHost) {
        btn.classList.add("external-link");
        btn.append(externalText);
      }
    }
  });
}
if (document.querySelector(".cta-btn")) {
  let currentHost = window.location.hostname;
  let ctaBtn = document.querySelector(".cta-btn");
  let ctaLink = ctaBtn.getAttribute("href").split("/");

  if (ctaLink[0] !== currentHost) {
    ctaBtn.classList.add("external-link");
    ctaBtn.append(externalText);
  }
}

////Pagination
if (document.querySelector(".navigation-pagination")) {
  let paginationList = document.querySelectorAll(
    ".navigation-pagination ul li"
  );

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

////Masonary
if (document.querySelector(".allcontainer")) {
  var elem = document.querySelector(".allcontainer");
  var msnry = new Masonry(elem, {
    // options
    itemSelector: ".item",
    columnWidth: ".grid-sizer",
    gutter: 15,
  });

  //Filters
  // const filterBtn = document.querySelectorAll('.filters button');
  // var allfilterBtn = Array.prototype.slice.call(filterBtn);
  //let allblocks = document.querySelectorAll('.item');
  let allblocks = Array.prototype.slice.call(
    document.querySelectorAll(".item")
  );
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;
    // if(selectedValue !== 'all'){
    //   allblocks = document.querySelectorAll('.item.block');
    // }
    allblocks.forEach(function (block) {
      block.classList.remove("block");

      if (selectedValue == "all") {
        block.classList.add("block");
      }

      if (block.getAttribute("data-cat") == selectedValue) {
        block.classList.add("block");
      }
    });
    msnry.layout();

    availableItems = Array.prototype.slice.call(
      document.querySelectorAll(".item.block")
    );
    document
      .getElementById("select")
      .addEventListener("change", onSelectChange);
  }

  availableItems = Array.prototype.slice.call(
    document.querySelectorAll(".item.block")
  );

  document.getElementById("select").addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function (item) {
      item.classList.remove("block");

      if (selectedOption == "all") {
        item.classList.add("block");
      }

      if (item.getAttribute("data-tag") == selectedOption) {
        item.classList.add("block");
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  /////Script_AJAX
  /* Ajax functions */
  $(document).ready(function () {
    //onclick
    $("#loadMore").on("click", function (e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data("page");
      var newPage = page + 1;
      var ajaxurl = that.data("url");
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: "post",
        data: {
          page: page,
          action: "ajax_script_load_more",
        },
        error: function (response) {
          console.log(response);
        },
        success: function (response) {
          //check
          if (response == 0) {
            $(".allcontainer").append(
              '<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>'
            );
            $("#loadMore").hide();
          } else {
            that.data("page", newPage);
            $("#ajax-primary").append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: ".item",
              columnWidth: ".grid-sizer",
              gutter: 15,
            });

            msnry.layout();
          }
        },
      });
    });
  });
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
  document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
  var btnbgColor = $(this).css("backgroundColor");
  var btnColor = $(this).css("color");

  $(this)
    .mouseenter(function () {
      $(this).css({
        "background-color": btnColor,
        color: btnbgColor,
        "border-color": btnColor,
      });
    })
    .mouseleave(function () {
      $(this).css({
        "background-color": btnbgColor,
        color: btnColor,
        "border-color": btnbgColor,
      });
    });
});

////categories button

let categoriesmenubtn = document.querySelector(
  ".category-menu .category-btn-cls"
);
let allcategoriesmenubtn = document.querySelector(
  ".category-mega-menu .all-category-btn-cls"
);
let categorymegamenudiv = document.querySelector(
  ".category-menu .category-mega-menu"
);
let categorymegamenudivcontainer = document.querySelector(
  ".category-mega-menu .mega-menu-container"
);
let filtercategorymegamenudiv = document.querySelector(
  ".category-menu .filter-category-mega-menu"
);
let categorymegamenubackbtn = document.querySelector(
  ".category-menu .category-mega-menu-back-btn"
);
let filtercategorymegamenubackbtn = document.querySelector(
  ".category-menu .filter-category-mega-menu-back-btn"
);

// keeping header open when categories menu is clicked
// 
// if(categoriesmenubtn){
//   categoriesmenubtn.addEventListener("click", function(e){
//     
//   })
// }


categoriesmenubtn.addEventListener("click", function (e) {
  e.preventDefault();
  
  categoriesmenubtn.classList.toggle("category-open");
  // console.log(categoriesmenubtn);
  categorymegamenudiv.classList.toggle("active");
  categorymegamenudivcontainer.style.display = "block";
  allcategoriesmenubtn.style.display = "block";
  filtercategorymegamenudiv.style.display = "none";
});

allcategoriesmenubtn.addEventListener("click", function (e) {
  e.preventDefault();
  categorymegamenubackbtn.style.display = "none";
  allcategoriesmenubtn.style.display = "none";
  categorymegamenudivcontainer.style.display = "none";
  filtercategorymegamenudiv.style.display = "block";
});

filtercategorymegamenubackbtn.addEventListener("click", function (e) {
  e.preventDefault();
  categorymegamenubackbtn.style.display = "block";
  allcategoriesmenubtn.style.display = "block";
  categorymegamenudivcontainer.style.display = "block";
  filtercategorymegamenudiv.style.display = "none";
});

categorymegamenubackbtn.addEventListener("click", function (e) {
  e.preventDefault();
  categorymegamenudiv.classList.toggle("active");
  //	categorymegamenubackbtn.style.display = 'block';
  categorymegamenudivcontainer.style.display = "block";
  allcategoriesmenubtn.style.display = "block";
  filtercategorymegamenudiv.style.display = "none";
});

////news categories button

let newscategoriesmenubtn = document.querySelector(
  ".news-category-menu .news-category-btn-cls"
);
let newsallcategoriesmenubtn = document.querySelector(
  ".all-news-category-btn-cls"
);
let newscategorymegamenudiv = document.querySelector(
  ".news-category-menu .news-category-mega-menu"
);
let newscategorymegamenudivcontainer = document.querySelector(
  ".news-category-mega-menu .mega-menu-container"
);
let newsfiltercategorymegamenudiv = document.querySelector(
  ".filter-news-category-mega-menu"
);
let newscategorymegamenubackbtn = document.querySelector(
  ".news-category-menu .news-category-mega-menu-back-btn"
);
let newsfiltercategorymegamenubackbtn = document.querySelector(
  ".news-category-menu .news-filter-category-mega-menu-back-btn"
);

let ps_header_wrapper = document.querySelector(".ps-header-wrapper");

if (newscategoriesmenubtn) {
  newscategoriesmenubtn.addEventListener("click", function (e) {
    e.preventDefault();

    newscategoriesmenubtn.classList.toggle("categories-open");
    if(ps_header_wrapper){
    ps_header_wrapper.classList.toggle("categories-menu-open");
    }
    newscategorymegamenudiv.classList.toggle("active");
    //newscategorymegamenubackbtn.style.display = 'block';
    newscategorymegamenudivcontainer.style.display = "block";
    newsallcategoriesmenubtn.style.display = "block";
    newsfiltercategorymegamenudiv.style.display = "none";
  });

  newsallcategoriesmenubtn.addEventListener("click", function (e) {
    e.preventDefault();
    console.log(newscategorymegamenudivcontainer);
    newscategorymegamenubackbtn.style.display = "none";
    newsallcategoriesmenubtn.style.display = "none";
    newscategorymegamenudivcontainer.style.display = "none";
    newsfiltercategorymegamenudiv.style.display = "block";

  });

  newsfiltercategorymegamenubackbtn.addEventListener("click", function (e) {
    e.preventDefault();
    newscategorymegamenubackbtn.style.display = "block";
    newsallcategoriesmenubtn.style.display = "block";
    newscategorymegamenudivcontainer.style.display = "block";
    newsfiltercategorymegamenudiv.style.display = "none";
  });

  newscategorymegamenubackbtn.addEventListener("click", function (e) {
    e.preventDefault();
    newscategorymegamenudiv.classList.toggle("active");
    //	categorymegamenubackbtn.style.display = 'block';
    newscategorymegamenudivcontainer.style.display = "block";
    newsallcategoriesmenubtn.style.display = "block";
    newsfiltercategorymegamenudiv.style.display = "none";
    ps_header_wrapper.classList.remove("categories-menu-open");
    console.log('scsc');
  });
}

let categorymenuatag = document.querySelectorAll(
  ".category-menu .filterbyalphabetic a"
);
if (categorymenuatag) {
  let firstcategoryelement = categorymenuatag[0];
  let lastcategoryelement = categorymenuatag[categorymenuatag.length - 1];
  firstcategoryelement.addEventListener("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      categorymegamenudiv.classList.remove("active");
    } else if (event.key === "Tab") {
      //console.log('Tab key was pressed');
    }
  });
  lastcategoryelement.addEventListener("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      //console.log('Shift + Tab was pressed');
    } else if (event.key === "Tab") {
      categorymegamenudiv.classList.remove("active");
      //console.log('Tab key was pressed');
    }
  });
}

let newscategorymenuatag = document.querySelectorAll(
  ".news-category-menu .filterbyalphabetic a"
);
if (newscategorymenuatag) {
  let firstcategoryelement = newscategorymenuatag[0];
  let lastcategoryelement =
    newscategorymenuatag[newscategorymenuatag.length - 1];
  if (firstcategoryelement) {
    firstcategoryelement.addEventListener("keydown", function (event) {
      if (event.shiftKey && event.key === "Tab") {
        newscategorymegamenudiv.classList.remove("active");
      } else if (event.key === "Tab") {
        //console.log('Tab key was pressed');
      }
    });
    lastcategoryelement.addEventListener("keydown", function (event) {
      if (event.shiftKey && event.key === "Tab") {
        //console.log('Shift + Tab was pressed');
      } else if (event.key === "Tab") {
        newscategorymegamenudiv.classList.remove("active");
        //console.log('Tab key was pressed');
      }
    });
  }
}

// search bar
let search_box_icon = document.querySelector(".site-header .search-menu .search-submit");
let search_box_close_icon = document.querySelector(".site-header .search-menu .search-close-icon");
let search_input_field = document.querySelector(".site-header .search-menu .search-field");
let search_box_wrapper = document.querySelector(".site-header .search-menu");

if (search_box_icon) {
  search_box_icon.addEventListener("click", function (e) {
    e.preventDefault;
    search_box_icon.setAttribute("tabindex", "-1");
    search_box_icon.blur();
    setTimeout(function () {
      search_input_field.focus();
    }, 100);

    search_box_wrapper.classList.add("active-search");
    if(document.querySelector("body").classList.contains("horo_home_video_body")){
      document.querySelector("body").classList.remove("horo_home_video_body");
      document.querySelector("body").classList.add("horo_home_video_body_temp");
    }
    
  });
}

if (search_box_close_icon) {
  search_box_close_icon.setAttribute("tabindex", "0");
  search_box_close_icon.addEventListener("click", function (e) {
    search_box_wrapper.classList.remove("active-search");
    if(document.querySelector("body").classList.contains("horo_home_video_body_temp")){
      document.querySelector("body").classList.add("horo_home_video_body");
      document.querySelector("body").classList.remove("horo_home_video_body_temp");
    }
    // document.querySelector("body").classList.add("horo_home_video_body");
    // let search_box_label = document.querySelector(".site-header .search-menu .search-label");
  });
  search_box_close_icon.addEventListener("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      // shfit and tab
    } else if (event.key === "Tab") {
      event.preventDefault();
      if (search_input_field) {
        setTimeout(function () {
          search_input_field.focus();
        }, 100);
      }

      //console.log('Tab key was pressed');
    } else if (event.keyCode === 13) {
      search_box_wrapper.classList.remove("active-search");
      if(document.querySelector("body").classList.contains("horo_home_video_body_temp")){
        document.querySelector("body").classList.add("horo_home_video_body");
        document.querySelector("body").classList.remove("horo_home_video_body_temp");
      }
      search_box_icon.setAttribute("tabindex", "0");
      if (search_box_icon) {
        setTimeout(function () {
          search_box_icon.focus();
        }, 100);
      }
    }
  });
}

// adding class on header while search is active
if(screen.width > 960){
  let header_with_search = document.querySelector(".site-header");
  let hide_menu = document.querySelector("header.site-header .menu-with-cta");
  if(search_box_icon){
    search_box_icon.addEventListener("click", function(){
      header_with_search.classList.add("searchbox_active");
      hide_menu.style.display = "none";
    })
  }
  if(search_box_close_icon){
    search_box_close_icon.addEventListener("click", function(){  
      if(header_with_search.classList.contains("searchbox_active")){
        header_with_search.classList.remove('searchbox_active');
        hide_menu.style.display = "flex";
      }
    })
  }
}


// header animation
if (screen.width > 960) {
  let headerForHoverAnimatio = document.querySelector(
    ".home header.site-header"
  );
  //if (headerForHoverAnimatio) {
  if (false) {
  var previousScrollpos = window.screenY;
  window.addEventListener("scroll", (event) => {
    var currentScrollPos = window.scrollY;
    let site_header = document.querySelector(".site-header");

   // if (previousScrollpos > currentScrollPos) {
      let scrollposfromtop = $(document).scrollTop();
      document.querySelector(".site-header").style.top = "0";
      site_header.classList.add("header-show");

      if (
        document
          .querySelector("body")
          .classList.contains("horo_home_video_body") &&
        document.querySelector("body").classList.contains("home") &&
        scrollposfromtop > 100
      ) {
        document.querySelector("body").classList.remove("horo_home_video_body");
      } else if (
        !document
          .querySelector("body")
          .classList.contains("horo_home_video_body") &&
        document.querySelector("body").classList.contains("home") &&
        scrollposfromtop < 100
      ) {
        if (!document.querySelector(".category-btn-cls").classList.contains("category-open")) {
        document.querySelector("body").classList.add("horo_home_video_body");
        }
      }
   
  });
  // getting header ready for mouse animation
  
    // mouse in animation in header (Home only)
    headerForHoverAnimatio.addEventListener("mouseover", function (e) {
      if (document.querySelector("body").classList.contains("aos-fade-down")) {
        document.querySelector("body").classList.remove("aos-fade-down");
      }
      if (
        document
          .querySelector("body")
          .classList.contains("horo_home_video_body")
      ) {
        document.querySelector("body").classList.remove("horo_home_video_body");
      }
    });
    // mouse leave animation on header (Home only)
    headerForHoverAnimatio.addEventListener("mouseleave", function (e) {
      if (
        !document
          .querySelector("body")
          .classList.contains("horo_home_video_body")
      ) {
        if (!document.querySelector(".category-btn-cls").classList.contains("category-open")) {
        document.querySelector("body").classList.add("horo_home_video_body");
        }
      }
      if (!document.querySelector("body").classList.contains("aos-fade-down")) {
        document.querySelector("body").classList.add("aos-fade-down");
      }
    });
  }
  else{
  var previousScrollpos = window.screenY;
  window.addEventListener("scroll", (event) => {
    var currentScrollPos = window.scrollY;
    if(currentScrollPos < 100){
      return false;
    }
    //console.log(currentScrollPos);
    let site_header = document.querySelector(".site-header");

    if (previousScrollpos > currentScrollPos) {
      let scrollposfromtop = $(document).scrollTop();
      document.querySelector(".site-header").style.top = "0";
      site_header.classList.add("header-show");

      if (
        document
          .querySelector("body")
          .classList.contains("horo_home_video_body") &&
        document.querySelector("body").classList.contains("home") &&
        scrollposfromtop > 100
      ) {
        document.querySelector("body").classList.remove("horo_home_video_body");
      } else if (
        !document
          .querySelector("body")
          .classList.contains("horo_home_video_body") &&
        document.querySelector("body").classList.contains("home") &&
        scrollposfromtop < 100
      ) {
        document.querySelector("body").classList.add("horo_home_video_body");
      }
    } else {
      if (
        !document
          .querySelector("body")
          .classList.contains("horo_home_video_body") &&
        document.querySelector("body").classList.contains("home")
      ) {
        document.querySelector("body").classList.add("horo_home_video_body");
      }
      document.querySelector(".site-header").style.top = "-100px";
      site_header.classList.remove("header-show");
    }
    previousScrollpos = currentScrollPos;
  });
  // getting header ready for mouse animation
  let headerForHoverAnimatio = document.querySelector(
    ".home header.site-header"
  );
  if (headerForHoverAnimatio) {
    // mouse in animation in header (Home only)
    headerForHoverAnimatio.addEventListener("mouseover", function (e) {
      if (document.querySelector("body").classList.contains("aos-fade-down")) {
        document.querySelector("body").classList.remove("aos-fade-down");
      }
      if (
        document
          .querySelector("body")
          .classList.contains("horo_home_video_body")
      ) {

          document.querySelector("body").classList.remove("horo_home_video_body");
      }
    });
    // mouse leave animation on header (Home only)
    headerForHoverAnimatio.addEventListener("mouseleave", function (e) {
      if (
        !document
          .querySelector("body")
          .classList.contains("horo_home_video_body")
      ) {
        if(!document.querySelector(".search-menu").classList.contains("active-search")){
          document.querySelector("body").classList.add("horo_home_video_body");
        }
       
      }
      if (!document.querySelector("body").classList.contains("aos-fade-down")) {
        document.querySelector("body").classList.add("aos-fade-down");
      }
    });
  }
}
}
else if(screen.width < 960){
  let headerForHoverAnimatio = document.querySelector(
    ".home header.site-header"
  );
  if (headerForHoverAnimatio) {
  var previousScrollpos = window.screenY;
  window.addEventListener("scroll", (event) => {
    var currentScrollPos = window.scrollY;
    let site_header = document.querySelector(".site-header");

   // if (previousScrollpos > currentScrollPos) {
      let scrollposfromtop = $(document).scrollTop();
      document.querySelector(".site-header").style.top = "0";
      site_header.classList.add("header-show");

      if (document.querySelector("body").classList.contains("horo_home_video_body") &&
        document.querySelector("body").classList.contains("home") &&
        scrollposfromtop > 100
      ) {
        document.querySelector("body").classList.remove("horo_home_video_body");
      } else if (!document.querySelector("body").classList.contains("horo_home_video_body") &&
        document.querySelector("body").classList.contains("home") &&
        scrollposfromtop < 100
      ) {
        document.querySelector("body").classList.add("horo_home_video_body");
      }
   
  });
  // getting header ready for mouse animation
  
    // mouse in animation in header (Home only)
    headerForHoverAnimatio.addEventListener("mouseover", function (e) {
      //if(e.target.classList.contains("search-submit")){
        
      if(false){
        if (document.querySelector("body").classList.contains("aos-fade-down")) {
          document.querySelector("body").classList.remove("aos-fade-down");
        }
        if (
          document
            .querySelector("body")
            .classList.contains("horo_home_video_body")
        ) {
          document.querySelector("body").classList.remove("horo_home_video_body");
        }
      }
      
    });
    // mouse leave animation on header (Home only)
    headerForHoverAnimatio.addEventListener("mouseleave", function (e) {
      if (
        !document
          .querySelector("body")
          .classList.contains("horo_home_video_body")
      ) {
        document.querySelector("body").classList.add("horo_home_video_body");
      }
      if (!document.querySelector("body").classList.contains("aos-fade-down")) {
        document.querySelector("body").classList.add("aos-fade-down");
      }
    });
  }
}

// popup animation
// let sharing_popup_div = document.querySelector(".link-sharing-wrapper");
// let sharing_popup_img = document.querySelector(".link-sharing-wrapper .pop-up-img .share-link-icon");
// let share_link_close_icon = document.querySelector(".link-sharing-wrapper .pop-up-img .share-link-close-icon");
// if (sharing_popup_img) {
//   sharing_popup_img.addEventListener("click", function (e) {
//     sharing_popup_div.classList.add("sharing-popup-open");
//     sharing_popup_img.parentElement.setAttribute("aria-expanded", true);
//     let copy_sharing_link = document.querySelector(".link-sharing-wrapper .copy-link-wrapper a");
//     copy_sharing_link.addEventListener("click", function(e){
//       copy_sharing_link.textContent = 'Copied';
//       copy_sharing_link.style["boxShadow"] = "none";  
//     })
//   });
//     share_link_close_icon.addEventListener("click", function(e){
//       sharing_popup_div.classList.remove("sharing-popup-open");
//       share_link_close_icon.parentElement.setAttribute("aria-expanded", false);
//   }) 

//   // opening on enter
//   sharing_popup_div.addEventListener("keydown", function (e) {
//     var menukeyCode = e.keyCode || e.which;
//     if (menukeyCode == 13) {
//       sharing_popup_div.classList.add("sharing-popup-open");
//       sharing_popup_img.parentElement.setAttribute("aria-expanded", true);
//       let copy_sharing_link = document.querySelector(".link-sharing-wrapper .copy-link-wrapper a");
//       if(copy_sharing_link){
//         copy_sharing_link.addEventListener("click", function(e){
//           copy_sharing_link.textContent = 'Copied';
//           copy_sharing_link.style["boxShadow"] = "none";  
//           if(menukeyCode == 9){
//             share_link_close_icon.parentElement.focus();
//           }
//         })

//       }
      
//       share_link_close_icon.addEventListener("click", function(e){
//         sharing_popup_div.classList.remove("sharing-popup-open");
//         share_link_close_icon.parentElement.setAttribute("aria-expanded", false);
//       })
//     }
//   }) 
// }

// let lastElementofBody = document.querySelector(".site-content");
// if(lastElementofBody){
//   lastElementofBody.addEventListener("focusout", function(e){
//     // console.log("focusout");
//     sharing_popup_img.focus();
//   });
// }

// subscribe cta
let subscribe_cta_close = document.querySelector(".sutd-wrapper .stud-left-content .subscribe-show-hide-btn");
let subscribe_right_content = document.querySelector(".sutd-wrapper .stud-right-content");
if (subscribe_cta_close) {
  subscribe_cta_close.addEventListener("click", function (e) {
    subscribe_right_content.classList.toggle("active");
    const psLabel = this.dataset.pslabel;
    if (subscribe_cta_close.classList.contains("open")) {
      subscribe_cta_close.classList.remove("open");
      subscribe_cta_close.classList.add("subscribe-show-hide-btn");
      subscribe_cta_close.innerHTML = psLabel;
    } else {
      subscribe_cta_close.classList.add("open");
      subscribe_cta_close.classList.remove("subscribe-show-hide-btn");
      subscribe_cta_close.innerHTML = "Close";
    }
    // console.log("subscribe me");
  });
}

let form_wrapper = document.querySelector(".sutd-wrapper");
let form_close_btn = document.querySelector(".sutd-wrapper  .close-btn");
if (form_close_btn) {
  form_close_btn.addEventListener("click", function (e) {
    form_wrapper.classList.toggle("form-expanded");
  });
}

// if(subscribe_cta_close){
// 	console.log('f');
// 	subscribe_cta_close.addEventListener("click", function(e){
// 		console.log('fx');
// 		console.log(e.target.parentElement.parentElement.classList.contains("form-opened"));
// 		if(e.target.parentElement.parentElement.classList.contains("form-opened")){

// 			e.target.parentElement.parentElement.classList.remove("form-opened");
// 		}
// 	})
// }
// article animation sticky and fullwidth on top
(function() {
  var previousScrollpos = window.screenY;
  window.addEventListener("scroll", (event) => {
    let in_this_articles_cls = document.querySelector(".in_this_articles_cls");
    if(!in_this_articles_cls){
      return false;
    }
    let articlecurrentposition = in_this_articles_cls.getBoundingClientRect().top;
    if (articlecurrentposition < 50) {
      in_this_articles_cls.classList.add("fullwidthonscrolltop");
    } 
    else{
      in_this_articles_cls.classList.remove("fullwidthonscrolltop");
    }
  });
  
  
})()

let pscurrentPage = 1;
$("#load-more").on("click", function () {
  pscurrentPage++; // Do currentPage + 1, because we want to load the next page
  $(this).attr("disabled", true);
  $(this).hide();
  $("#infinite-loader").show();
  var perpage = $(this).data("perpage");
  var excludepost = $(this).data("excludepost");
  var ajaxurl = ps_ajaxUrl;
  $.ajax({
    type: "POST",
    url: ajaxurl,
    dataType: "html",
    data: {
      action: "ps_load_more",
      paged: pscurrentPage,
      perpage: perpage,
      excludepost: excludepost
    },
    success: function (res) {
      var json_html = JSON.parse(res);
      $("#load-more").attr("disabled", false);
      $("#load-more").show();
      $("#infinite-loader").hide();
      if (json_html.max == 1) {
        $("#load-more").hide();
      }
      $(".news-list").append(json_html.html);
    },
  });
});

let psarchivecurrentPage = 1;
$("#load-more-btn").on("click", function () {
  psarchivecurrentPage++; // Do currentPage + 1, because we want to load the next page
  $(this).attr("disabled", true);
  $(this).hide();
  $("#infinite-loader").show();
  var perpage = $(this).data("perpage");
  var termtype = $(this).data("termtype");
  var termid = $(this).data("termid");
  var psyear = $(this).data("psyear");
  var psmonth = $(this).data("psmonth");
  var psday = $(this).data("psday");
  var searchkeyword = $(this).data("searchkeyword");
  //console.log(termid);
  var ajaxurl = ps_ajaxUrl;
  $.ajax({
    type: "POST",
    url: ajaxurl,
    dataType: "html",
    data: {
      action: "ps_load_more",
      paged: psarchivecurrentPage,
      perpage: perpage,
      termtype: termtype,
      termid: termid,
      psyear: psyear,
      psmonth: psmonth,
      psday: psday,
      searchkeyword: searchkeyword
    },
    success: function (res) {
      var json_html = JSON.parse(res);
      $("#load-more-btn").attr("disabled", false);
      $("#load-more-btn").show();
      $("#infinite-loader").hide();
      if (json_html.max == 1) {
        $("#load-more-btn").hide();
      }
      $(".news-list").append(json_html.html);
    },
  });
});

document.addEventListener(
  "wpcf7submit",
  function (event) {
    //event.preventDefault();
    var submitButton = document.getElementById("subscribe-btn");
    if(submitButton){
      submitButton.value = "Done";
    }
  },
  false
);

// document.addEventListener( 'wpcf7mailsent', function( event ) {
//     var submitButton = document.getElementById( 'your-submit-button-id' );
//     submitButton.innerHTML = 'Done';
// }, false );

let textreader_progressbar = document.querySelector(".progress-bar");

if (textreader_progressbar) {
  window.addEventListener("scroll", (event) => {
    fn_textreader_progressbar();
    onScroll_in_this_articles();
  });
  function fn_textreader_progressbar() {
    var winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    var height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.getElementById("ps_bar").style.width = scrolled + "%";
  }
}



// preventing footer focus unless fully shown
window.onscroll = function (ev) {
  if (
    window.innerHeight + window.scrollY >= document.body.offsetHeight - 50 &&
    window.innerWidth > 960
  ) {
    let allfooteranchors = document.querySelectorAll("#footer-top a");
   // console.log(allfooteranchors);
    if (allfooteranchors) {
      for (let i = 0; i < allfooteranchors.length; i++) {
        allfooteranchors[i].setAttribute("tabindex", "0");
      }
    }

    // disable the tabbing icon for first item in footer menu
    let footer_menu_first_item = document.querySelectorAll("#footer-top .footer-top-menu ul#menu-footer-menu > li > a");
   // console.log(footer_menu_first_item);
    if(footer_menu_first_item){
      for (let i = 0; i < footer_menu_first_item.length; i++) {
        footer_menu_first_item[i].setAttribute("tabindex", "-1");
      }
    }
  } 
  // else {
  //   let allfooteranchors = document.querySelectorAll("#footer-top a");
  //   if (allfooteranchors) {
  //     for (let i = 0; i < allfooteranchors.length; i++) {
  //       allfooteranchors[i].setAttribute("tabindex", "-1");
  //     }
  //   }
  // }
};

// for showing footer
let footer_talk_btn= document.querySelector("#footer-top .talk_to_us");
if(footer_talk_btn){
  footer_talk_btn.addEventListener("keydown", (e) => {  
    if (e.key === "Tab"){
      var height = document.body.scrollHeight;
      window.scroll(0 , height);
      // console.log("Tab Key Pressed");
    } else {
      // console.log("Tab Key Not Pressed"); 
    }
  }
  )
}

// in this article section js
let inthisarticle = document.querySelector(".in_this_articles_cls");
if (inthisarticle) {
  inthisarticle.addEventListener("click", function (e) {
    inthisarticle.classList.toggle("expanded");
  });
}

(function () {
  let all_firstslide = document.querySelectorAll(".aos-fade-left-five-h");
  let all_secondslide = document.querySelectorAll(".aos-fade-left-eight-h");
  let all_thirdslide = document.querySelectorAll(".aos-fade-left-twelve-h");
  //  Fade left animation
  let aos_fade_left_animation = document.querySelectorAll(".aos-fade-left");
  //  Fade right animation
  let aos_fade_right_animation = document.querySelectorAll(".aos-fade-right");
  //  Fade right animation slow
  let aos_fade_right_slow_animation = document.querySelectorAll(
    ".aos-fade-right-slow"
  );
  //  Fade up animation
  let aos_fade_up_animation = document.querySelectorAll(".aos-fade-up");
  //  Fade down animation
  let aos_fade_down_animation = document.querySelectorAll(".aos-fade-down");
  //  Zoom in animation
  let aos_zoom_in_animation = document.querySelectorAll(".aos-zoom-in");
  //  Zoom out animation
  let aos_zoom_out_animation = document.querySelectorAll(".aos-zoom-out");

  if (all_firstslide) {
    for (let i = 0; i < all_firstslide.length; i++) {
      all_firstslide[i].setAttribute("data-aos", "fade-left");
      all_firstslide[i].setAttribute("data-aos-duration", "500");
      // all_firstslide[i].setAttribute("data-aos-offset","100");
    }
  }
  if (all_secondslide) {
    for (let i = 0; i < all_secondslide.length; i++) {
      all_secondslide[i].setAttribute("data-aos", "fade-left");
      all_secondslide[i].setAttribute("data-aos-duration", "800");
      // all_secondslide[i].setAttribute("data-aos-offset","400");
    }
  }
  if (all_thirdslide) {
    for (let i = 0; i < all_thirdslide.length; i++) {
      all_thirdslide[i].setAttribute("data-aos", "fade-left");
      all_thirdslide[i].setAttribute("data-aos-duration", "1200");
      // all_thirdslide[i].setAttribute("data-aos-offset","800");
    }
  }

  //  Fade left animation
  if (aos_fade_left_animation) {
    for (let i = 0; i < aos_fade_left_animation.length; i++) {
      aos_fade_left_animation[i].setAttribute("data-aos", "fade-left");
    }
  }
  //  Fade right animation
  if (aos_fade_right_animation) {
    for (let i = 0; i < aos_fade_right_animation.length; i++) {
      aos_fade_right_animation[i].setAttribute("data-aos", "fade-right");
    }
  }
  //  Fade right animation slow
  if (aos_fade_right_slow_animation) {
    for (let i = 0; i < aos_fade_right_slow_animation.length; i++) {
      aos_fade_right_slow_animation[i].setAttribute("data-aos", "fade-right");
      aos_fade_right_slow_animation[i].setAttribute(
        "data-aos-duration",
        "1200"
      );
    }
  }
  //  Fade up animation
  if (aos_fade_up_animation) {
    for (let i = 0; i < aos_fade_up_animation.length; i++) {
      aos_fade_up_animation[i].setAttribute("data-aos", "fade-up");
    }
  }
  //  Fade down animation
  if (aos_fade_down_animation) {
    for (let i = 0; i < aos_fade_down_animation.length; i++) {
      aos_fade_down_animation[i].setAttribute("data-aos", "fade-down");
    }
  }
  //  Zoom in animation
  if (aos_zoom_in_animation) {
    for (let i = 0; i < aos_zoom_in_animation.length; i++) {
      aos_zoom_in_animation[i].setAttribute("data-aos", "zoom-in");
    }
  }
  //  Zoom out animation
  if (aos_zoom_out_animation) {
    for (let i = 0; i < aos_zoom_out_animation.length; i++) {
      aos_zoom_out_animation[i].setAttribute("data-aos", "zoom-out");
    }
  }
})();

(function () {
  var vimeoIframes = document.querySelectorAll(".ps-hero-videos iframe");
  if (!vimeoIframes) {
    return false;
  }
  for (let i = 0; i < vimeoIframes.length; i++) {
    var vimeoPlayer = new Vimeo.Player(vimeoIframes[i]);
    // sent to about us
    vimeoIframes[i].parentNode
      .querySelector(".iframe-overlay")
      .addEventListener("click", function () {
        var psClickableValue = this.getAttribute('data-psclickable');
        var psLinkValue = this.getAttribute('data-psLink');
        if(psClickableValue === 'yes'){
        window.location = psLinkValue;
        }
      });
    
    vimeoPlayer.on("loaded", function () {
      vimeoIframes[i].parentNode.parentNode.querySelector(
        ".loader"
      ).style.display = "none";
      vimeoPlayer.setVolume(0);
        // mute unmute
        vimeoIframes[i].parentNode.parentNode
        .querySelector(".mute-button")
        .addEventListener("click", function () {
          vimeoPlayer.getVolume().then(function (volume) {
            var muteButton =
              vimeoIframes[i].parentNode.parentNode.querySelector(".mute-button");
            if (volume > 0) {
              vimeoPlayer.setVolume(0);
              muteButton.textContent = "Unmute";
            } else {
              vimeoPlayer.setVolume(1);
              muteButton.textContent = "Mute";
            }
          });
        });
    });
  }
})();

// jobs open div js
let job_card_div = document.querySelectorAll(
  ".jobs-card-wrapper ul li .view-btn-div .view-job-details-btn"
);
if (job_card_div) {
  for (let i = 0; i < job_card_div.length; i++) {
    job_card_div[i].addEventListener("click", function () {
      job_card_div[i].parentElement.parentElement.classList.toggle(
        "job-view-content"
      );
    });
  }
}

jQuery(function ($) {
  var searchRequest;
  $(".search-autocomplete").autoComplete({
    minChars: 2,
    source: function (term, suggest) {
      try {
        searchRequest.abort();
      } catch (e) {}
      searchRequest = $.post(
        ps_ajaxUrl,
        { search: term, action: "jobs_autocomplete" },
        function (res) {
          suggest(res.data);
        }
      );
    },
  });
});

let mobile_filter_div = document.querySelector(
  ".jobs-filter-wrapper .mobile-fiter-container"
);
if (mobile_filter_div) {
  mobile_filter_div.addEventListener("click", function () {
    let job_seach_form = document.querySelector(".job-search-bar-section");
    job_seach_form.style.display = "block";
  });
}

// (function () {
//   // popup redirection js
//   let job_apply_btn_clicked = document.querySelector(
//     ".single-jobs .job_detail_section .job_sticky_section .job_apply a"
//   );
//   let popup_redirection_wrapper = document.querySelector(
//     ".popup-redirection-wrapper"
//   );
//   if (!job_apply_btn_clicked) {
//     return false;
//   }
//   // console.log('has job');
//   job_apply_btn_clicked.addEventListener("click", function (e) {
//     e.preventDefault();
//     let buttonhref = e.currentTarget.href;
//     popup_redirection_wrapper.classList.toggle("show-popup-modal");
//     document.querySelector("body header").style.display = "none";
//     // document.querySelector("body").style.overflow = "hidden";
//     setTimeout(function () {
//       location.href = buttonhref;
//     }, 3000);
//   });
// })();

(function () {
  // popup redirection js
  let job_apply_btns_clicked = document.querySelectorAll(
    ".single-jobs .job_apply a"
  );
  let popup_redirection_wrapper = document.querySelector(
    ".popup-redirection-wrapper"
  );
  if (!job_apply_btns_clicked) {
    return false;
  }
  // console.log('has job');
  for(let i = 0; i < job_apply_btns_clicked.length; i++){
    let job_apply_btn_clicked = job_apply_btns_clicked[i];
    job_apply_btn_clicked.addEventListener("click", function (e) {
      e.preventDefault();
      let buttonhref = e.currentTarget.href;
      popup_redirection_wrapper.classList.toggle("show-popup-modal");
      document.querySelector("body header").style.display = "none";
      // document.querySelector("body").style.overflow = "hidden";
      setTimeout(function () {
        location.href = buttonhref;
      }, 3000);
    });
  }
  
})();

function onScroll_in_this_articles(e) {
var in_this_articles_section = document.getElementById("in_this_articles_id");
if (document.body.scrollTop > 30 || document.documentElement.scrollTop > 30) {
  in_this_articles_section.style.position = "fixed";
  in_this_articles_section.style.left = "0px"
  in_this_articles_section.style.marginTop = "0px"
} else {
  in_this_articles_section.style.position = "sticky";
  in_this_articles_section.style.marginTop = "12px";
}
}

// Adding slick slider
(function(){
  window.addEventListener("load", (event) => {
    let slickcarousal = document.querySelectorAll('.slick-carousel');
    if(slickcarousal){ 
        jQuery('.slick-carousel').slick({
          slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        dots: false,
        speed: 300,
        centerPadding: '20px',
        infinite: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
        });
      
    }
  });
})()
  
 
// Adding in this article active class on news single page
$(document).ready(function () {
  if ($('.right-content').length) { // Check if "right-content" class exists
      $(document).on("scroll", onScroll);
      
      $('.right-content a[href^="#"]').on('click', function (e) {
          e.preventDefault();
          $(document).off("scroll");
          
          $('.right-content a').each(function () {
              $(this).removeClass('active');
          })
          $(this).addClass('active');
        
          var target = this.hash,
              menu = target;
          $target = $(target);
          $('html, body').stop().animate({
              'scrollTop': $target.offset().top+2
          }, 500, 'swing', function () {
              window.location.hash = target;
              $(document).on("scroll", onScroll);
          });
      });
  }
});

function onScroll(event){
  var scrollPos = $(document).scrollTop();
  var refElement;
  $('.right-content a').each(function () {
      refElement = $(this.hash);
      if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
          $('.right-content a').removeClass("active");
          $(this).addClass("active");
          return false; // break the loop
      }
  });
}
(function(){
  let horizantal_hero_logo = document.querySelector(".horizantal_hero_logo");
  if(!horizantal_hero_logo){
      return false;
  }
  // top logo animation on home page
  gsap.registerPlugin(ScrollTrigger);
let initialScrullScrub = 0;
gsap.to(".horizantal_hero_logo", {
  //value: 100, // Rotate to horizontal
  // rotation: 0, // Rotate to horizontal
  // width: "50px", // Make it smaller
  // x: "0%", // Move to left corner
  scrollTrigger: {
      trigger: ".ps-hero-videos",
      //trigger: "body",
      start: "center center", // When the top of SVG hits the center of viewport
      end: "bottom top", // When the bottom of SVG hits the top of viewport
      scrub: true, // Smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      onUpdate: (self) => {
  // these are some sample variable which we can use
//	console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
   if(initialScrullScrub == 0){
    initialScrullScrub = self.progress;
   }
      updateHorizentalLogoHomePage((self.progress - initialScrullScrub) * 100)
  },
  }
});

})()
function updateHorizentalLogoHomePage(progress, selector = ".horizantal_hero_logo"){
  let elem =document.querySelectorAll(selector);
  if(!elem){
      return false;
  }
  for(let i = 0; i < elem.length; i++){
      let defaultimagewidth = 10;
      let animationstartwidth = 5;
      let widthdecreasepercentage = 2;
      if(screen.width < 960){
          defaultimagewidth = 30;
          animationstartwidth = 10;
          widthdecreasepercentage = 1;
      }
      
      
      if(progress > animationstartwidth){
      let rotatedegre = 360/100 * progress;
      let width = defaultimagewidth - (progress/widthdecreasepercentage);
      elem[i].style.transform = "rotate(-"+rotatedegre+"deg)";
      elem[i].style.width = width+"vw";
      elem[i].style.left = progress * (progress / 100)+"px";
      elem[i].style.top = 100 * (progress / 100)+"px";
     // console.log((100 - Math.floor(progress)> 99)?100:(100 - Math.floor(progress))/1000);
      elem[i].style.opacity = (100 - Math.floor(progress))/((progress / 100 ) * 1000) - .3;
  }
  else{
      elem[i].style.transform = "rotate(0deg)";
      elem[i].style.width = defaultimagewidth+"vw";
      elem[i].style.left = 0;
      elem[i].style.top = 0;
      elem[i].style.opacity = 1;
  }
  }
  
}


window.addEventListener('scroll', function() {
  let iframeOffset = window.pageYOffset;
  let winheight = 600;
  if(screen.width < 960){
    let winheight = 150;
  }
  if(iframeOffset > winheight){
     // vimeo mute code
     var vimeoIframes = document.querySelectorAll(".ps-hero-videos iframe");
     if (!vimeoIframes) {
       return false;
     }
     for (let i = 0; i < vimeoIframes.length; i++) {
       var vimeoPlayer = new Vimeo.Player(vimeoIframes[i]);
           vimeoPlayer.getVolume().then(function (volume) {
            //  console.log("clicked", volume);
             var muteButton =
               vimeoIframes[i].parentNode.parentNode.querySelector(".mute-button");
             if (volume > 0) {
               vimeoPlayer.setVolume(0);
               muteButton.textContent = "Unmute";
             }
           });
     }
     // vimeo mute code
  }
});


( function() { 'use strict';
  let images = document.querySelectorAll('img[data-src]');
              
  document.addEventListener('DOMContentLoaded', onReady);
  function onReady() {
    // Show above-the-fold images first
    showImagesOnView();

    // scroll listener
    window.addEventListener( 'scroll', showImagesOnView, false );
  }
  
  // Show the image if reached on viewport
  function showImagesOnView( e ) {
    
    for( let i of images ) {
      if( i.getAttribute('src') ) { continue; } // SKIP if already displayed
      
      // Compare the position of image and scroll
      let bounding = i.getBoundingClientRect();
      let isOnView = bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
      
      if( isOnView ) {
        i.setAttribute( 'src', i.dataset.src );
        if( i.getAttribute('srcset') ) {
          i.setAttribute( 'srcset', i.dataset.srcset );
        }
      }
    }
  }
              
})();

// hiding search icon and menu icon when category menu is open
if (screen.width < 960) {
  let categories_icon = document.querySelector(".site-header .category-menu .category-btn-cls");
  let search_icon = document.querySelector(".site-header .search-menu");
  let mobile_menu_icon = document.querySelector(".site-header .only-mobile-menu");
  let category_back_btn = document.querySelector(".site-header .category-mega-menu-back-btn.only-mobile");
  let sitebranding = document.querySelector(".site-branding");
 
  if(categories_icon){
    categories_icon.addEventListener("click", function(){
      search_icon.style.display = "none";
      mobile_menu_icon.style.display = "none";
      if(sitebranding){
        sitebranding.style.display ="none";
      }
    })
  }
  if(category_back_btn){
    category_back_btn.addEventListener("click", function(){
      search_icon.style.display = "block";
      mobile_menu_icon.style.display = "block";
      if(sitebranding){
        sitebranding.style.display ="block";
      }
    })
  }
   
}


// Declaring custom functions
// removeTrailingCommas : function to remove trailing commas from a string
function removeTrailingCommas(str) {
  let regex = /\,(?!\s*?[\{\[\"\'\w])/g;
  return str.replace(regex, '');
}
// calculateRadius : Function to calculate maximum radius of circle which can fit in a given rectangle
function calculateRadius(width, height) {
  // Determine the smaller of the two dimensions
  let smallerDimension = Math.min(width, height);

  // The radius of the circle that can fit inside the rectangle
  // is half of the smaller dimension
  let radius = smallerDimension / 2;

  return radius;
}


// load more case study
let ps_cs_currentPage = 1;
$("#cs-load-more").on("click", function () {
  var selectedcasestudy = $('#selectedcasestudy').val();
  if(selectedcasestudy <= 3){
    $('#selectedcasestudy').val(4);
    // ps_cs_currentPage--;
  } else {
    ps_cs_currentPage++;
  }
   // Do currentPage + 1, because we want to load the next page
  $(this).attr("disabled", true);
  $(this).hide();
  $("#cs-infinite-loader").show();
  var perpage = $(this).data("perpage");
  var termslug = $(this).data("termslug");
  var termctslug = $(this).data("termctslug");
  var layout = $(this).data("layout");
  var post_not_in = $(this).data("post_not_in");
  if (layout !== undefined && layout !== null) {
    datalayout = layout;
} else {
  datalayout = 1;
}
  var ajaxurl = ps_ajaxUrl;
  $.ajax({
    type: "POST",
    url: ajaxurl,
    dataType: "html",
    data: {
      action: "ps_case_studies_load_more",
      paged: ps_cs_currentPage,
      perpage: perpage,
      termslug: termslug,
      termctslug: termctslug,
      post_not_in: post_not_in,
      layout: datalayout
    },
    success: function (res) {
      var json_html = JSON.parse(res);
      $("#cs-load-more").attr("disabled", false);
      $("#cs-load-more").show();
      $("#cs-infinite-loader").hide();
      if (json_html.max == 1) {
        $("#cs-load-more").hide();
      }
      $(".case_studies_container").append(json_html.html);
    },
  });
});

let pslatestnewscurrentPage = 1;
$("#latest-news-cs-load-more").on("click", function () {
  pslatestnewscurrentPage++; // Do currentPage + 1, because we want to load the next page
  $(this).attr("disabled", true);
  $(this).hide();
  $("#latest-news-infinite-loader").show();
  var perpage = $(this).data("perpage");
  var ajaxurl = ps_ajaxUrl;
  $.ajax({
    type: "POST",
    url: ajaxurl,
    dataType: "html",
    data: {
      action: "ps_latest_news_load_more",
      paged: pslatestnewscurrentPage,
      perpage: perpage,
    },
    success: function (res) {
      var json_html = JSON.parse(res);
      $("#latest-news-cs-load-more").attr("disabled", false);
      $("#latest-news-cs-load-more").show();
      $("#latest-news-infinite-loader").hide();
      if (json_html.max == 1) {
        $("#latest-news-cs-load-more").hide();
      }
      $(".latest-news-list").append(json_html.html);
    },
  });
});

let pslatestpressreleasescurrentPage = 1;
$("#latest-press-release-cs-load-more").on("click", function () {
  pslatestpressreleasescurrentPage++; // Do currentPage + 1, because we want to load the next page
  $(this).attr("disabled", true);
  $(this).hide();
  $("#latest-press-release-infinite-loader").show();
  var perpage = $(this).data("perpage");
  var category = $(this).data("category");
  var psexcludepost = $(this).data("psexcludepost");
  var ajaxurl = ps_ajaxUrl;
  $.ajax({
    type: "POST",
    url: ajaxurl,
    dataType: "html",
    data: {
      action: "ps_latest_press_release_load_more",
      paged: pslatestpressreleasescurrentPage,
      perpage: perpage,
      category: category,
      psexcludepost:psexcludepost
    },
    success: function (res) {
      var json_html = JSON.parse(res);
      $("#latest-press-release-cs-load-more").attr("disabled", false);
      $("#latest-press-release-cs-load-more").show();
      $("#latest-press-release-infinite-loader").hide();
      if (json_html.max == 1) {
        $("#latest-press-release-cs-load-more").hide();
      }
      $(".latest-press-release-list").append(json_html.html);
    },
  });
});

let psmostpopularnewscurrentPage = 1;
$("#most-popular-cs-load-more").on("click", function () {
  psmostpopularnewscurrentPage++; // Do currentPage + 1, because we want to load the next page
  $(this).attr("disabled", true);
  $(this).hide();
  $("#most-popular-infinite-loader").show();
  var msperpage = $(this).data("msperpage");
  var post_not_in = $(this).data("post_not_in");
  var mscat = $(this).data("mscat");
  var ajaxurl = ps_ajaxUrl;
  $.ajax({
    type: "POST",
    url: ajaxurl,
    dataType: "html",
    data: {
      action: "ps_most_popular_load_more",
      paged_load_more: psmostpopularnewscurrentPage,
      mpperpage: msperpage,
      post_not_in: post_not_in,
      mscat:mscat,
    },
    success: function (res) {
      var json_html = JSON.parse(res);
      $("#most-popular-cs-load-more").attr("disabled", false);
      $("#most-popular-cs-load-more").show();
      $("#most-popular-infinite-loader").hide();
      if (json_html.max == 1) {
        $("#most-popular-cs-load-more").hide();
      }
      $(".most-popular-news-list").append(json_html.html);
    },
  });
});
///////////
// Google tag manager work
function trackCTAClicks() {
  const ctaButtons = document.querySelectorAll('.wp-block-button__link, .subscribe-btn, .talk_to_us, .wpcf7-submit, .subscribe-show-hide-btn'); // Adjust selector as needed
  ctaButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Get relevant details for tracking
      var buttonText = button.textContent.trim();
      if(buttonText == '')
      buttonText = button.value;
      const buttonHref = button.getAttribute('href');
      const sourcePage = window.location.href; // Get current page URL
      const referrerURL = document.referrer;
      const scrollDepth = window.scrollY;

 
      // Send GA event using gtag.js (Google Analytics 4)
      gtag('event', 'cta_click', {
        event_category: 'engagement',
        event_label: buttonText,
        value: buttonHref,
        source: sourcePage,
        referrer: referrerURL,
        scroll_depth: scrollDepth,
        transport_type: 'beacon', // Prioritize beacon for efficiency
        event_callback: () => {
          // Redirect after successful tracking (optional)
          if (buttonHref) {
            window.location.href = buttonHref;
          }
        }
      });
    });
  });
}
// calling this function
trackCTAClicks();

// Cookie Preferences
let CookiePreferencesBtn = document.querySelector(".ot-sdk-show-settings a");
if (CookiePreferencesBtn) {
  CookiePreferencesBtn.addEventListener("click", function (e) {
    e.preventDefault();
    CookieControl.open();
  });
}



// Check if there are any buttons in the document
if (document.querySelectorAll('.page-template-amchart-latest-template .accordion-container button.ac-q').length > 0) {
  // Add event listener to all images inside buttons
  document.querySelectorAll('.page-template-amchart-latest-template .accordion-container button.ac-q img').forEach(function(img) {
    img.addEventListener('click', function(event) {
      // Trigger click on the parent button
      var button = event.target.closest('button');
      if (button) {
        button.click();
      }
    });
  });
}

// code to animate number on case study page

function scrolling_number_animate() {
  const statisticsSectionsSelector =
    ".more_case_studies_grid_section .grid_statistics .label_val p";

  const observerOptions = {
    root: null,
    threshold: 0.5,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      const element = entry.target;
      const textContent = element.textContent.trim();

      if (entry.isIntersecting && /\d/.test(textContent)) {
        animateCounter(element);
        observer.unobserve(element);
      }
    });
  }, observerOptions);

  // Function to observe all elements
  function observeElements() {
    const sections = document.querySelectorAll(statisticsSectionsSelector);
    sections.forEach((section) => {
      if (!section.dataset.observed) {
        observer.observe(section);
        section.dataset.observed = true;
      }
    });
  }

  observeElements();

  // Function to animate numbers
  function animateCounter(element) {
    const textContent = element.textContent.trim();
    const numericValue = parseInt(textContent.replace(/\D/g, "")); // Extract the number
    const suffix = textContent.replace(/[0-9,]/g, ""); // Extract the non-numeric suffix (e.g., ',' or '+')
  
    let startValue = 0;
    const duration = 1000; // Animation duration
    const totalSteps = Math.min(50, numericValue); // Smoothness of animation
    const increment = Math.ceil(numericValue / totalSteps); // Step increment
    const stepTime = duration / totalSteps;
  
    const timer = setInterval(() => {
      startValue += increment;
  
      // Prevent exceeding the target value
      if (startValue >= numericValue) {
        startValue = numericValue;
        clearInterval(timer);
      }
  
      // Format number with commas and append suffix
      element.textContent = startValue.toLocaleString() + suffix;
    }, stepTime);
  }  

  // Handle "Load More" Button Click
  const loadMoreButton = document.querySelector(".load-more-btn");
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", () => {
      
      const container = document.querySelector(".case_studies_grid_container");

      // Check for content changes with MutationObserver
      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          observeElements();
        });
      });

      if (container) {
        mutationObserver.observe(container, { childList: true, subtree: true });
      } 

      setTimeout(() => {
        observeElements(); // Fallback re-observation
        mutationObserver.disconnect();
      }, 1000);
    });
  } 
}


// code to animate number on category and services page
function scrolling_number_animate_counter() {
  const statistics_services_category =
    ".more_case_studies_section .statistics .label_val p";

  const observerOptions = {
    root: null,
    threshold: 0.5,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const element = entry.target;
      const textContent = element.textContent.trim();

      if (entry.isIntersecting && /\d/.test(textContent)) {
        animateCounter(element);
        observer.unobserve(element); // Stop observing once animated
      }
    });
  }, observerOptions);

  // Function to observe all elements
  function observeElements() {
    const sections = document.querySelectorAll(statistics_services_category);
    sections.forEach((section) => {
      if (!section.dataset.observed) {
        observer.observe(section);
        section.dataset.observed = "true";
      }
    });
  }

  observeElements(); // Observe elements on initial load

  // Function to animate numbers
  function animateCounter(element) {
    const textContent = element.textContent.trim();
    const numericValue = parseInt(textContent.replace(/\D/g, "")); // Extract the number
    const suffix = textContent.replace(/[0-9,]/g, ""); // Extract the non-numeric suffix (e.g., ',' or '+')
  
    let startValue = 0;
    const duration = 1000; // Animation duration
    const totalSteps = Math.min(50, numericValue); // Smoothness of animation
    const increment = Math.ceil(numericValue / totalSteps); // Step increment
    const stepTime = duration / totalSteps;
  
    const timer = setInterval(() => {
      startValue += increment;
  
      // Prevent exceeding the target value
      if (startValue >= numericValue) {
        startValue = numericValue;
        clearInterval(timer);
      }
  
      // Format number with commas and append suffix
      element.textContent = startValue.toLocaleString() + suffix;
    }, stepTime);
  }

  // Handle "Load More" Button Click
  const loadMoreButton = document.querySelector(".load-more-btn");
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", () => {
      const container = document.querySelector(".case_studies_container");

      // Wait for new content to load and observe new elements
      setTimeout(() => {
        observeElements(); // Ensure new elements are observed
      }, 500); // Adjust timeout as needed based on load time

      // Use MutationObserver to handle dynamic content
      if (container) {
        const mutationObserver = new MutationObserver(() => {
          observeElements();
        });

        mutationObserver.observe(container, { childList: true, subtree: true });

        // Optionally disconnect the observer after some time
        setTimeout(() => {
          mutationObserver.disconnect();
        }, 2000);
      }
    });
  }
}


document.addEventListener("DOMContentLoaded", () => {
  scrolling_number_animate();
  scrolling_number_animate_counter();
  ps_share_btn();
  psexternalLoginForm();
  
});


// Initialize current page variable
let ps_cs_grid_currentPage = 1;

$("#cs-grid-load-more").on("click", function () {
    ps_cs_grid_currentPage++;

  // Disable the button and show loader while fetching data
  $(this).attr("disabled", true);
  $(this).hide();
  $("#cs-infinite-loader").show();

  // Gather data from the button attributes
  var perpage = $(this).data("perpage");
  var termcsserviceslug = $(this).data("termcsserviceslug");
  var termctslug = $(this).data("termctslug");

  // Check if the site is on localhost and update the API URL accordingly
  var apiUrl = window.location.hostname === 'localhost' ? 'http://localhost/peoplescout-work/tmpw-dev-new/wordpress/wp-json/ps/v1/load_more_case_studies' : '/wp-json/ps/v1/load_more_case_studies';

  // Prepare the data to send in the request
  var requestData = {
    termcsserviceslug: termcsserviceslug,
    termctslug: termctslug,
    perpage: perpage,
    paged: ps_cs_grid_currentPage,
  };

  // Send the AJAX request to the REST API
  $.ajax({
    type: "POST",
    url: apiUrl,
    dataType: "json",  // Expect JSON response from the REST API
    contentType: "application/json",  // Send data as JSON
    data: JSON.stringify(requestData),  // Convert data to JSON string
    success: function (response) {
      $("#cs-grid-load-more").attr("disabled", false);
      $("#cs-grid-load-more").show();
      $("#cs-infinite-loader").hide();

      // If there are no more posts, hide the Load More button
      if (response.max === 1) {
        $("#cs-grid-load-more").hide();
      }

      // Append the new case studies to the container
      var caseStudiesHtml = '';
      response.data.forEach(function (item) {
        caseStudiesHtml += `
          <div class="more_case_studies_grid_section">
            <a href="${item.permalink}" aria-label="${item.title}">
              <div class="more_case_studies_grid_image">
                <img src="${item.image.url}" alt="${item.image.alt}" />
              </div>
                <div class="more_case_studies_grid_title">
                  ${item.sub_heading ? `<p>${item.sub_heading}</p>` : ''}
                  ${item.heading ? `<p>${item.heading}</p>` : ''}
                  </div>
            </a>
              <div class="more_case_studies_grid_content">
                  <div class="news_posts-category-list">
                                ${item.terms.map(term => `
                                    <a href="${term.term_link}" class="${term.term_name} ${term.term_class}">
                                        ${term.term_name}
                                    </a>
                                `).join('')}
                            </div>
                  <div class="content">
                  ${item.hero_content ? `<p>${item.hero_content}</p>` : ''}
                  </div>
                  ${item.statistics.length > 0 ? `
                    <div class="grid_statistics">
                      ${item.statistics.map(function(stat) {
                        return `
                          <div class="inner_statistics">
                            <div class="label">
                              <p><span class="underline">${stat.label}</span></p>
                            </div>
                            <div class="label_val">
                              <p>${stat.value}</p>
                            </div>
                          </div>
                        `;
                      }).join('')}
                    </div>
                  ` : ''}
              </div>
          </div>
        `;
      });

      // Append the generated HTML to the case studies container
      $(".case_studies_grid_container").append(caseStudiesHtml);
    },
    error: function () {
      // Handle error if the request fails
      // alert("An error occurred while loading more case studies.");
      $("#cs-load-more").attr("disabled", false);
      $("#cs-load-more").show();
      $("#cs-infinite-loader").hide();
    }
  });
});

function ps_share_btn(){
  let sharebutton = document.getElementById('shareButton');
  if(sharebutton){
    sharebutton.onclick = function() {
      const currentUrl = window.location.href; // Get the current URL
      if (navigator.share) {
          // If the Web Share API is supported
          navigator.share({
              title: document.title, // Title of the page
              url: currentUrl // URL to share
          });
      } 
  };
  }

  }

  function psexternalLoginForm() {
    const forms = document.querySelectorAll(".psexternalLoginForm");
    
    forms.forEach((form) => {
        const emailField = form.querySelector(".psextEmail");
        const passField = form.querySelector(".psextPassword");
        const msg = form.querySelector(".psextMsg");
        const button = form.querySelector("button");

        button.addEventListener("click", async function (e) {
            e.preventDefault();

            const email = emailField.value.trim();
            const password = passField.value.trim();
            msg.style.color = "#ff8585";
            msg.textContent = "";

            if (!email || !password) {
                msg.textContent = "Please fill in both fields.";
                return;
            }

            try {
                const formData = new FormData();
                formData.append("action", "ps_self_service_login_action");
                formData.append("email", email);
                formData.append("password", password);
                var ajaxurl = ps_ajaxUrl;
                const response = await fetch(ajaxurl, {
                    method: "POST",
                    body: formData
                });

                const result = await response.json();
                if (result.success) {
                    msg.style.color = "#3cbe91";
                    msg.textContent = "Login successful. Redirecting...";
                    setTimeout(() => {
                       window.location.href = result.data.redirect_url;
                    }, 1000);
                } else {
                    msg.textContent = result.message || "Incorrect login id or password. Please try again.";
                }
            } catch (error) {
                msg.textContent = "Request failed. Try again.";
            }
        });
    });
}


document.addEventListener('DOMContentLoaded', () => {
  enableHorizontalScroll('.ps_tabs_component.tabwithimage .tablist');
});

function enableHorizontalScroll(selector) {
  const tablist = document.querySelector(selector);
  if (!tablist) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  // Drag to scroll
  tablist.addEventListener('mousedown', (e) => {
    isDown = true;
    tablist.classList.add('scrolling');
    startX = e.pageX - tablist.offsetLeft;
    scrollLeft = tablist.scrollLeft;
  });

  tablist.addEventListener('mouseleave', () => {
    isDown = false;
    tablist.classList.remove('scrolling');
  });

  tablist.addEventListener('mouseup', () => {
    isDown = false;
    tablist.classList.remove('scrolling');
  });

  tablist.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - tablist.offsetLeft;
    const walk = (x - startX) * 1.5;
    tablist.scrollLeft = scrollLeft - walk;
  });

  // Horizontal scroll with mouse wheel
  tablist.addEventListener('wheel', (e) => {
    if (e.deltaY !== 0) {
      e.preventDefault();
      tablist.scrollLeft += e.deltaY;
    }
  }, { passive: false });
}
